import request,{openMessage} from '../utils/request';
import verification from '../utils/verification/index';

export default {

    data(){
        return {
            config:{
                default:'发送验证码',
                time:60,
                before:'',
                after:'s后重新发送'
            },
            exportData:{
                text: '',
                disabled: false
            }
        }
    },

    methods:{
        startTime(item) {

            if (this.exportData.disabled) return;
            let next = true;

            verification.verification({
                data:this.inputData.filter((cItem)=> cItem.key === item.code),
                complete:(data)=>{
                    if (this.exportData.disabled || !next) return ;
                    this.exportData.disabled = true;
                    request.$request({
                        url:'index/lenovo/hit_sms_20221228',
                        data:data.value
                    });

                    this.clearTime();
                    this.endTime = +new Date() + (this.config.time * 1000);

                    return  this.setItem();
                },
                cache(item){
                    openMessage('info',item.tip)
                }
            })

        },

        setItem() {
            let diff = Math.ceil((this.endTime - (+new Date()))/1000);
            this.exportData.disabled = diff > 0;
            if (diff > 0) {
                this.exportData.text = this.config.before + diff + this.config.after;
                this.time = setTimeout(()=> this.setItem(),1000);
            } else {
                this.exportData.text = this.config.default;
                this.clearTime();
            }
        },
        clearTime() {
            clearTimeout(this.time);
        }

    },

    created() {
        this.endTime = this.time = undefined;
        this.exportData.text = this.config.default;
    }

}
